import { getProblemAddressesApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    GetProblemAddressesResponse,
    ProblemAddressResponse,
    ProblemAddressesApiGetProblemAddressesRequest,
    VerifyAddressPointRequest,
} from '@/core/generated/api';

/** Выполняет операции проверки координат домов */
export const problemAddressService = {
    /** Возвращает страницу домов */
    async getList(
        query: ProblemAddressesApiGetProblemAddressesRequest,
        signal?: AbortSignal
    ): Promise<GetProblemAddressesResponse> {
        try {
            const response = await getProblemAddressesApi().getProblemAddresses(query, { signal });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Возвращает координаты и историю проверки дома */
    async getDetails(id: string, signal?: AbortSignal): Promise<ProblemAddressResponse> {
        try {
            const response = await getProblemAddressesApi().getProblemAddress({ id }, { signal });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Сохраняет результат ручной проверки координат */
    async verify(id: string, request: VerifyAddressPointRequest): Promise<ProblemAddressResponse> {
        try {
            const response = await getProblemAddressesApi()
                .verifyAddressPoint({
                    id,
                    verifyAddressPointRequest: request
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
